module.exports = __webpack_public_path__ + "static/media/PE.e1a724f7.svg";